import * as React from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootReducer } from "../app/reducer"
import { objectFormData } from "../../utils/formdata"
import "./index.css"
import { useHistory } from "react-router"

import { AxiosResponse } from "axios"
import api from "../../data/api"
// type TableData<T, K extends keyof T> = {
//     [P in K]: T[P];
// }

// type TableData<T> = {
//     [P in keyof T | "TableDataColumn"]? : string;
// }


// type PermissibleType = Ismag ;


// type Props = {
//     cols: TableData<PermissibleType>[],
//    // data: object[]
// }

// const issuer:Ismag = { adherence: "r", ctry: "c",  issuerName: "d"}
// const issuers: Ismag[] = [ issuer ]


// const issuerUP: TableData<Ismag>[] = [{ ...issuer, "TableDataColumn" : "Radek"}]
export type TableHeader<T> = {
    [P in keyof T]: string
}

type Props<K> = {
     //cols: TableData<PermissibleType>[],
    header: TableHeader<K>
    data: K[] | undefined,
    searchCriteria?: FormData,
    urlCSV?: string ,
    urlXML?: string,
    recordsOnPage: number,
    leadingColumnContent?: (item: Object) => JSX.Element,
    
    customColumnIndex?: number,
    customExplainHandler?: () => any
}

//const issuer : Ismag = { adherence:"a", ctry: "b", issuerName:"c"}
//const header : TableHeader<Ismag> = {adherence: "heaer1", ctry:"header2", issuerName: "header3"}

// we are listing objects her because we can,
// but in general this can be arbitrary object
export const ResultsCl: React.FC<Props<Object>> = (props) => {
    // local state, not conneced to Redux
    const rootDispatch = useDispatch()
    const currentPage = useSelector( (state:RootReducer) =>  state.resultTableReducer.currentPage )

    const propsData = props.data ? props.data : []
    const paginateData = 
        propsData.filter( (obj,index) => (index >= (currentPage -1)*props.recordsOnPage) && (index < Math.ceil((currentPage)*props.recordsOnPage) ) ) 
    
        // console.log("Results table paginate array: " + JSON.stringify(paginateData))
        // console.log("Props heder" + JSON.stringify(props.header,null,4))
    // for all paginated data
    // for a row iterate over header keys and for each headerkey find a corresponding val in the rowObject
    // entries does {"ctry":"cz", "iso":"EN123"} -> [ ["ctry","cz"],["iso","EN123"] ] so the
    // [0] in cmparison is for the index, [0] (first dereference ) is taking the only array that came through the filter
    // and [1] is the actual value ( "cz" and "EN123" respectively)
    // since all the statements are returns (arrow functions) the result is array of values in the correct order
    const arrReorderedByHeader = paginateData.map( (rowObject) => 
        Object.keys(props.header).map( headerKey => 
            Object.entries( rowObject ).filter( arrKeyVal => arrKeyVal[0] === headerKey)[0][1]
        )
     )

     // now for example header {"iso": "National Norm", "ctry": "In Country" }
     // the following data [{"ctry":"cz", "iso":"EN123"}, {"ctry":"de", "iso":"EN677"}] has become [ ["EN123", "cz"], ["EN677", "de"]]
     // the items inthe arrays are in the same order as the header items


     //console.log("Results table Reordered array by header: " + JSON.stringify(arrReorderedByHeader))
    const NBSP = "\u00a0"
    const history = useHistory();           

    React.useEffect(() => {
        return (()=>{
            rootDispatch({type: "ResultTable/RESETPAGING"})
        })
    },[rootDispatch])
    // {props.cols.map( (colName, i) => 
    //     <th>{colName}</th>
    // )}

    // this is required in testing (lot of the same data)
    // <td className="datatable-column" key={value + generate()}>{props.leadingColumnContent ? props.leadingColumnContent(arrRow) : value}</td>)}
    let uniqueNum = 1;
    const generate = () => uniqueNum++
    
    //formData is used to get object from FormData passed as property
    const formData = () => {if (props.searchCriteria) return objectFormData(props.searchCriteria)};
    const getFormData = formData();        
    
    const convertObjToArray = (formData : any) => {
        //expected input { code: "07", name: "---", city: "---" ...}
        const arrayData : Object[] = [];
        const keys  = Object.keys(formData);        
        keys.forEach( key => {
            arrayData.push({[key] : formData[key]});
        });
        //example of result  [{"code":"07"}, {"name":"---"}, {"city":"---"} ...]
        return arrayData;
     };
    
    const arrData = convertObjToArray(getFormData);

    const displayXML = () => { 
        if (props.searchCriteria && props.urlXML) {
            api
            .post(props.urlXML,  objectFormData(props.searchCriteria)) 
            .then( (response:AxiosResponse) => {                    
                let xmlData = response.data;        
                let blob = new Blob([xmlData], {type: 'text/xml'});
                let url = URL.createObjectURL(blob);
                let openWindow = window.open(url, 'Download as XML', 'height=600,width=900');
                openWindow?.focus();
                URL.revokeObjectURL(url); //Releases the resources    
            })
        }
    }
    
    const save = (saveAsType: string) => { history.push({pathname:"/SaveAs", state:saveAsType}) }

    return(
        <div>
            <div className="pagination">
                <span className="prev-link navigation"> 
                { currentPage !== 1 ? 
                    <span onClick={()=> rootDispatch({type: "ResultTable/DECREMENTPAGE"})}>Prev</span> : NBSP}
                </span> 
                <span className="page-num">
                    Page <span className="bold">{currentPage}</span> of <span className="bold">{Math.ceil(propsData.length / props.recordsOnPage)}</span>
                </span>
                <span className="next-link navigation">
                { currentPage !== Math.ceil(propsData.length / props.recordsOnPage) ? 
                    <span onClick={()=> rootDispatch({type: "ResultTable/INCREMENTPAGE"})}>Next</span> : NBSP}
                </span>
            </div>
            <div className="result-tab">
                <table>
                    <thead>
                        <tr className="datatable-header">
                            {Object.values(props.header).map( headerString =>     <th key={headerString}>{headerString}</th>   )}
                        </tr>
                    </thead>
                    <tbody>
                        {arrReorderedByHeader.map( (arrRow, index) => 
                        <tr className={index%2 === 0 ? "datatable-row-white" : "datatable-row-grey"} key={arrRow.join("|") + generate()} >
                            {arrRow.map( (value, colIndex:number) => 
                                   
                                (colIndex === props.customColumnIndex && props.customExplainHandler) ? (
                                    <td className="datatable-column navigation" onClick={props.customExplainHandler} key={value + generate()}>{value}</td>
                                ) : (colIndex===0 && props.leadingColumnContent) ? (
                                    <td className="datatable-column" key={value + generate()}>{ props.leadingColumnContent(paginateData[index]) }</td>
                                ) : (
                                    <td className="datatable-column" key={value + generate()}>{ value }</td>
                                )
                            )} 
                        </tr>   )}
                    </tbody>                    
                </table>
            </div>           
            
            <div className="download">
                <div className="csv"> 
                    {props.urlCSV?.indexOf("Security") === -1 ?                                                   
                        <form action={props.urlCSV} method="post">
                            {/*example of arrData  [{"code":"07"}, {"name":"---"}, {"city":"---"} ...]*/}
                            {/*generates as many <input> as is objects in the arrData */}
                            {arrData.map((singleObject : {[index: string]:any} ) => (         
                                <input type="hidden" id={Object.keys(singleObject)[0]} name={Object.keys(singleObject)[0]} value={singleObject[Object.keys(singleObject)[0]]} />     
                            ))}                        
                            <button name="Download" formTarget="_blank" type="submit" >Download as CSV</button>
                        </form>  
                    :   <button name="Download" onClick={() => save('CSV')}>Download as CSV</button>
                    }                  
                </div>
                <div className="xml">
                    {props.urlCSV?.indexOf("Security") === -1 ? 
                        <button name="Download" onClick={displayXML}>Download as XML</button>
                    :   <button name="Download" onClick={() => save('XML')}>Download as XML</button>
                }
                </div>                 
            </div>

            <div className="pagination">
                <span className="prev-link navigation"> 
                { currentPage !== 1 ? 
                    <span onClick={()=> rootDispatch({type: "ResultTable/DECREMENTPAGE"})}>Prev</span> : NBSP}
                </span> 
                <span className="page-num">
                    Page <span className="bold">{currentPage}</span> of <span className="bold">{Math.ceil(propsData.length / props.recordsOnPage)}</span>
                </span>
                <span className="next-link navigation">
                { currentPage !== Math.ceil(propsData.length / props.recordsOnPage) ? 
                    <span onClick={()=> rootDispatch({type: "ResultTable/INCREMENTPAGE"})}>Next</span> : NBSP}
                </span>
            </div>
        </div>
    )
}

